import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons/static";
import { themeRoundnessMultiplier } from "../../constants";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type CircularIconContainerProps = {
	iconName: IconType;
	size?: number;
	iconSize?: number;
	backgroundColor?: string;
	iconColor?: string;
	variant?: "square" | "circular";
};

export const CircularIconContainer = ({
	iconName,
	size = 80,
	iconSize = 36,
	backgroundColor,
	iconColor,
	variant = "circular",
}: CircularIconContainerProps) => {
	const theme = useAppTheme();

	return (
		<Box
			width={size}
			height={size}
			borderRadius={
				variant === "circular"
					? size / 2
					: theme.roundness * themeRoundnessMultiplier
			}
			backgroundColor={backgroundColor ?? theme.colors.primaryContainer}
			justifyContent="center"
			alignItems="center"
		>
			<MaterialCommunityIcons
				name={iconName}
				size={iconSize}
				color={iconColor ?? theme.colors.onPrimaryContainer}
			/>
		</Box>
	);
};
